var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 4H4.8125C4.28207 4 3.77336 4.21071 3.39829 4.58579C3.02321 4.96086 2.8125 5.46957 2.8125 6V20C2.8125 20.5304 3.02321 21.0391 3.39829 21.4142C3.77336 21.7893 4.28207 22 4.8125 22H18.8125C19.3429 22 19.8516 21.7893 20.2267 21.4142C20.6018 21.0391 20.8125 20.5304 20.8125 20V13",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 2.50023C19.7103 2.1024 20.2499 1.87891 20.8125 1.87891C21.3751 1.87891 21.9147 2.1024 22.3125 2.50023C22.7103 2.89805 22.9338 3.43762 22.9338 4.00023C22.9338 4.56284 22.7103 5.1024 22.3125 5.50023L12.8125 15.0002L8.8125 16.0002L9.8125 12.0002L19.3125 2.50023Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIc);
export default __webpack_public_path__ + "static/media/edit_ic.7cc353ebddb1e56103eb7977a3b241db.svg";
export { ForwardRef as ReactComponent };